import { render, staticRenderFns } from "./PhoneVerifyModal.vue?vue&type=template&id=ff989a36&scoped=true"
import script from "./PhoneVerifyModal.vue?vue&type=script&lang=js"
export * from "./PhoneVerifyModal.vue?vue&type=script&lang=js"
import style0 from "./PhoneVerifyModal.vue?vue&type=style&index=0&id=ff989a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff989a36",
  null
  
)

export default component.exports